module.exports = __webpack_public_path__ + "media/images/logo-a68e5a54a0c422228849a8b5b494946f.svg";